import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./context/AuthContext";
import { AudioPlayerProvider } from "./context/AudioPlayerContext";
import { ThemeProvider } from "./context/ThemeContext";
import { DateFormatProvider } from "./context/DateFormatContext";
import { EventColorProvider } from "./context/EventColorContext";
import { UIPreferencesProvider } from "./context/UIPreferencesContext";
import { OnboardingProvider } from "./context/OnboardingContext";
import { VATProvider } from "./context/VATContext";
import { LayoutProvider } from "./components/layout/LayoutProvider";
import { ToastProvider } from "./components/ui/Toast";
import App from "./App";
import "./index.css";

// Create query client with default options
const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 0, // Always stale — ensures mutations invalidate+refetch immediately
			retry: 1,
			refetchOnWindowFocus: false,
		},
	},
});

// Get the root element
const container = document.getElementById("root");

if (!container) {
	throw new Error("Root element not found");
}

// Render the app
createRoot(container).render(
	<StrictMode>
		<BrowserRouter>
			<QueryClientProvider client={queryClient}>
				<ThemeProvider>
					<AuthProvider>
						<LayoutProvider>
							<DateFormatProvider>
								<EventColorProvider>
									<UIPreferencesProvider>
										<OnboardingProvider>
											<VATProvider>
												<AudioPlayerProvider>
													<ToastProvider>
														<App />
													</ToastProvider>
												</AudioPlayerProvider>
											</VATProvider>
										</OnboardingProvider>
									</UIPreferencesProvider>
								</EventColorProvider>
							</DateFormatProvider>
						</LayoutProvider>
					</AuthProvider>
				</ThemeProvider>
			</QueryClientProvider>
		</BrowserRouter>
	</StrictMode>
);